import React from 'react';

const SlideActions = ({ onShare, onNext, nextButtonText, imageUrl, language, onPrev }) => {
  return (
    <div className="deadline__actions">
      {onShare && (
        <button 
          onClick={onShare} 
          className="deadline__footer"
          disabled={!imageUrl}
        >
          {language === 'RUS' ? 'Поделиться в Историях' : 'Share in Stories'}
        </button>
      )}
      {onPrev && (
        <button 
          onClick={onPrev} 
          className="deadline__footer"
          disabled={!imageUrl}
        >
          {language === 'RUS' ? 'Назад' : 'Back'}
        </button>
      )}
      <button onClick={onNext} className="deadline__footer">
        {nextButtonText ? nextButtonText : language === 'RUS' ? 'Дальше' : 'Next'}
      </button>
    </div>
  );
};

export default SlideActions; 